import { invalidateSingleEntryCache } from 'api/urql/helpers/mutation';

export const deleteCustomJobReport = (results, args, cache, info) => {
  // handlers go here
  invalidateSingleEntryCache('CustomJobReport')(
    results,
    args,
    cache,
    info
  );
};
